import React from "react";

/**
 * Phoenix brand badge. Not a shadcn wrapper (badge.jsx variants are too
 * limited) — tokens are applied directly.
 */
export function PhxBadge({ tone = "neutral", children, className = "", ...rest }) {
  const tones = {
    neutral: "bg-[var(--phx-slate-100)] text-[var(--phx-slate-700)]",
    primary: "bg-[var(--phx-brand-primary)] text-white",
    success: "bg-[var(--phx-status-success-surface)] text-[var(--phx-status-success)]",
    danger:  "bg-[var(--phx-status-danger-surface)] text-[var(--phx-status-danger)]",
    warning: "bg-[var(--phx-status-warning-surface)] text-[var(--phx-status-warning)]",
    info:    "bg-[var(--phx-status-info-surface)] text-[var(--phx-status-info)]",
    muted:   "bg-[var(--phx-slate-200)] text-[var(--phx-slate-700)]",
  };
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded-[var(--phx-radius-sm)] ${tones[tone] || tones.neutral} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
